export default {
  SET_ADDRESS(state, address) {
    state.address = address;
  },
};
